var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashGrayLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25L16 18",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25L23 18",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 11.375H34.125H33.25C31.3644 11.375 30.4216 11.375 29.8358 11.9608C29.25 12.5466 29.25 13.4894 29.25 15.375V28.5C29.25 30.3856 29.25 31.3284 28.6642 31.9142C28.0784 32.5 27.1356 32.5 25.25 32.5H13.75C11.8644 32.5 10.9216 32.5 10.3358 31.9142C9.75 31.3284 9.75 30.3856 9.75 28.5V15.375C9.75 13.4894 9.75 12.5466 9.16421 11.9608C8.57843 11.375 7.63562 11.375 5.75 11.375H4.875Z",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1533 6.48236C15.4097 6.0571 15.9747 5.68131 16.7606 5.41329C17.5465 5.14528 18.5094 5 19.5 5C20.4906 5 21.4535 5.14527 22.2394 5.41329C23.0253 5.68131 23.5903 6.05709 23.8467 6.48236",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGrayLarge);
export default __webpack_public_path__ + "static/media/trash-gray-large.232785bd413a884c18338967eec46981.svg";
export { ForwardRef as ReactComponent };